import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Grid, Typography
} from "@mui/material";

import { t, Trans } from "@lingui/macro";

import { ZPlayAutocomplete } from "commons/fields";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface SeriesLanguageDataState {
    languages: any
}

export interface SeriesLanguageDataProps {
    name: string
    languageList: any
}

export class SeriesLanguageData extends React.Component<SeriesLanguageDataProps & UseFormReturn, SeriesLanguageDataState> {

    constructor(props: any) {

        super(props);

        this.state = {
            languages: this.props.languageList,
        };
    }

    render() {
        return (
            <Accordion sx={{ backgroundColor: process.env.REACT_APP_THIRD_COLOR }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                        <Trans id={"sld-language-subtitle-section"}>Lingua e sottotitoli</Trans>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container item xs={12} md={4} mb={3}>
                        <ZPlayAutocomplete
                            fieldName={`${this.props.name}.language`}
                            label={t({
                                id: "sld-language",
                                message: "Lingua originale"
                            })}
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}
                            data={this.state.languages} />
                    </Grid>
                </AccordionDetails>
            </Accordion>)
    }
}